import { isPlainObject } from 'lodash';

const NUMBERS_REGEX = /^-?\d+$/;

const replaceBooleanString = (val) => {
  if (val === 'true') {
    return true;
  }

  if (val === 'false') {
    return false;
  }
  return val;
};

export default ({
  source,
  valueKey = 'value',
  textKey = 'text',
  convertKeysToNumbers = true,
}) => {
  const isArray = Array.isArray(source);
  const isArrayValidOptions = isArray && source.some(item => (isPlainObject(item) && Object.prototype.hasOwnProperty.call(item, valueKey) &&
    Object.prototype.hasOwnProperty.call(item, textKey)));

  if (isArrayValidOptions) {
    return source.map(item => {
      if (item[valueKey]) {
        return ({
          ...item,
          [valueKey]:
            convertKeysToNumbers && NUMBERS_REGEX.test(item[valueKey])
              ? +item[valueKey]
              : item[valueKey],
        });
      }

      return item;
    });
  }

  const options = Object.keys(source).map((key) => {
    const value = isArray ? replaceBooleanString(source[key]) : replaceBooleanString(key);
    const text = isPlainObject(source[key]) ? source[key][textKey] : source[key];
    const item = {
      [valueKey]: convertKeysToNumbers && NUMBERS_REGEX.test(key) ? +value : value,
      [textKey]: text,
    };

    if (isPlainObject(source[key]) && source[key].helpText) { item.helpText = source[key].helpText; }
    if (isPlainObject(source[key]) && source[key].subtitle) { item.subtitle = source[key].subtitle; }

    return item;
  });

  const otherIndex = options.findIndex(option => option[textKey]?.toLowerCase() === 'other');

  if (otherIndex > 0) {
    [options[otherIndex], options[options.length - 1]] = [options[options.length - 1], options[otherIndex]];
  }

  return options;
};
